import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Spin, DatePicker } from 'antd';
import moment from 'moment';

import RefillsList from './RefillsList';
import { SET_DATE_CALLS, SET_REFILLS } from '../../ActionTypes/ActionTypes';

class DateCalls extends Component {
    state = {
        loading: false,
    }

    componentDidMount = () => {
        // const { setRefills } = this.props;
        const { date, setRefills, setDateCalls } = this.props;

        if (date == null) {
            setDateCalls(moment().format('YYYY-M-D'));
        }
        this.setState({ loading: true });
        axios({
            method: 'get',
            url: `/carefills/refill_calls_on_date.json?date=${date}`,
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                console.log(response.data);
                setRefills(response.data.carefills);
                this.forceUpdate();
                this.setState({
                    loading: false,
                });
            });
    }

    onDateChange = (date, dateString) => {
        // this.setState({
        //     date: dateString,
        // });
        const { setDateCalls } = this.props;
        setDateCalls(dateString);
        window.location.reload();
        // this.setState({ loading: true });
        // axios({
        //     method: 'get',
        //     url: `/carefills/refill_calls_on_date.json?date=${dateString}`,
        //     headers: { Authorization: sessionStorage.getItem('jwtToken') },
        // })
        //     .then((response) => {
        //         console.log(response.data);
        //         setRefills(response.data.carefills);
        //         this.forceUpdate();
        //         this.setState({
        //             loading: false,
        //         });
        //     });
    }


    render() {
        const { loading } = this.state;
        const { date } = this.props;

        return (
            <div>

                <div
                    style={{ margin: 40 }}
                >
                    <DatePicker
                        value={moment(date)}
                        onChange={this.onDateChange}
                    />
                </div>


                {
                    loading
                        ? <Spin />
                        : <RefillsList />
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    date: state.RefillState.date,
});

const mapDispatchToProps = dispatch => ({
    setRefills: data => dispatch({ type: SET_REFILLS, payload: { data } }),
    setDateCalls: data => dispatch({ type: SET_DATE_CALLS, payload: { data } }),
});

export default connect(mapStateToProps, mapDispatchToProps)(DateCalls);



// WEBPACK FOOTER //
// ./src/component/RefillManagementSystem/DateCalls.js